import * as React from "react";
import * as ReactDOM from "react-dom";
import { ReactifySearchLiquidFactory, Sensors } from "@usereactify/search";
import { Collection } from "@app/scripts/reactify/collection/components/collection";

// Same guard as search/index.tsx: no #reactify-data means the Nosto provider is selected, and letting getData()
// throw would take the search drawer down with it.
if (window.location.pathname.startsWith("/collection") && document.getElementById("reactify-data")) {
    const ReactifySearchFactory = new ReactifySearchLiquidFactory({
        mode: "collection",
        includeFields: ["title", "tags", "metafields", "variants.*", "images", "url", "media"],
        excludeFields: [],
    });
    const ReactifySearchProvider = ReactifySearchFactory.getProvider();
    const ReactifySearchMountNode = ReactifySearchFactory.getMountNode();
    const ReactifySearchData = ReactifySearchFactory.getData();


    ReactDOM.render(
        <React.StrictMode>
            <ReactifySearchProvider>
                <Sensors />
                <Collection collection={ReactifySearchData} />
            </ReactifySearchProvider>
        </React.StrictMode>,
        ReactifySearchMountNode
    );
}
